import React, { useState, Fragment, useEffect, useRef } from "react";

import "./userStyles.css";
import data from "./mock-data.json";
import ReadOnlyRow from "./ReadOnlyRow";
import EditableRow from "./EditableRow";

import Cookies from "js-cookie";

import { Circles } from "react-loader-spinner";

import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import { Divider } from "@tremor/react";

import { useSelector } from "react-redux";
import { fetchCompanies } from "../../../redux/companySlice";
import { useDispatch } from "react-redux";

//receipt componenent
import ClassPrinter from "../twRecords/receipts/ClassPrinter";


//pdf creator
import jsPDF from "jspdf";
// import "jspdf-autotable";

// import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';

const TwUsers = () => {
  const [contacts, setContacts] = useState(data);
  const [addFormData, setAddFormData] = useState({
    username: "",
    farmerid: "",
    email: "",
    fullname: "",
    firstName: "",
    lastName: "",
    company: "",
    category: "",
    gender:"",
    phone: "",
  });

  const [editFormData, setEditFormData] = useState({
    id: "",
    username: "",
    email: "",
    joined: "",
    company: "",
    category: "",
    phone: "",
    gender:"",
    status: "",
  });

  const [editContactId, setEditContactId] = useState(null);

  //display success info after successful registration
  const [success, setSuccess] = useState("");

  const [deleteState, setDeleteState] = useState("");

  const [foundErr, setFoundErr] = useState(null);
  const [foundErrAdd, setFoundErrAdd] = useState(null);
  const [isLoading, setIsLoading] = useState(null);
  const [isLoadingAdd, setIsLoadingAdd] = useState(null);
  const [isLoadingSave, setIsLoadingSave] = useState(null);

  //analysis Constants
  const [totalUsers, settotalUsers] = useState(null);

  const [totalActiveUsers, settotalActiveUsers] = useState(null);

  //store select values in an array
  const options = [
    { value: "", text: "-- select Category --" },
    { value: "farmer", text: "farmer" },
    { value: "Clerk", text: "Clerk" },
    { value: "Admin", text: "Admin" },
  ];


    const optionsGender = [
    { value: "", text: "-- select gender --" },
    { value: "male", text: "male" },
    { value: "female", text: "female" },
  ];

  //store select company values in an array
  const companies = [
    { value: "", text: "-- select company--" },
    { value: "Terraweb", text: "Terraweb" },
    { value: "Gatamura Dairy", text: "Gatamura Dairy" },
    { value: "Mbuuni Coffee", text: "Mbuuni Coffee" },
    { value: "Kanyua Tea", text: "Kanyua Tea" },
  ];

  const [val, setVal] = useState("");

  const [names, setNames] = useState({
    fullname: "",
    farmerid: "",
    category: options[0].value,
    username: "",
    company: "",
    phone: val,
    gender: optionsGender[0].value,
    status: "",
  });

  const dispatch = useDispatch();
  //fetch companies using get

  const companiesList = useSelector((state) => state.companies?.list || []);

  useEffect(() => {
    dispatch(fetchCompanies());
  }, [dispatch]);


  //number options
  const numberOptions = [
    { value: "", text: "10" },
    { value: "10", text: "10" },
    { value: "25", text: "20" },
    { value: "50", text: "20" },

    { value: "100", text: "20" },
  ];

  //search users in your company
  const [searchUser, setSearchUser] = useState("");

  //accept numbers only

  //clear inputs
  const firstnameref = useRef();
  const lastnameref = useRef();
  const fullnameRef = useRef();
  const usernameRef = useRef();
  const emailRef = useRef();
  const passwordRef = useRef();
  const phoneRef = useRef();
  const companyRef = useRef();
  const categoryRef = useRef();
  const genderRef = useRef();

  //creating a fullname formatter here so that fullname data goes into the dataabase in the
  //form of firstname Lastname
  // Function to format the full name
  const formatFullName = (firstName, lastName) => {
    // Ensure the first letter of each name is capitalized
    const formattedFirstName =
      firstName.charAt(0).toUpperCase() + firstName.slice(1);
    const formattedLastName =
      lastName.charAt(0).toUpperCase() + lastName.slice(1);

    // Combine the formatted names into the full name
    const fullName = `${formattedFirstName} ${formattedLastName}`;

    return fullName;
  };

  //format the company to start with capital letter and remove white spaces
  // Function to format the company name
  const formatCompanyName = (input) => {
    // Remove leading and trailing white spaces
    const trimmedInput = input.trim();

    // Ensure the first letter is capitalized
    const formattedCompanyName =
      trimmedInput.charAt(0).toUpperCase() + trimmedInput.slice(1);

    return formattedCompanyName;
  };

  //handle company input
  const onCompanyChange = (event) => {
    if (names.company.length >= 3) {
      setFoundErrAdd("");
    } else {
      setFoundErrAdd("An error occurred");
    }
    const newCompanyName = event.target.value;
    const formattedCompanyName = formatCompanyName(newCompanyName);

    // Spreading "...state" ensures we don't "lose" fname,lname,email... etc
    setNames((names) => ({
      ...names,
      company: formattedCompanyName,
    }));

    setAddFormData((prevState) => ({
      ...prevState,
      company: formattedCompanyName,
    }));
  };
  
  const handleCompanyChange = (event) => {
  setSuccess(null);
    setNames((names) => ({
      ...names,
      company: event.target.value,
    }));

    event.preventDefault();

    const fieldName = event.target.getAttribute("name");
    const company = event.target.value;

    const newFormData = { ...addFormData };
    newFormData["company"] = company;
console.log(newFormData.company)
    setAddFormData(newFormData);
  };


  // handle on category change
  const handleCategoryEdit = (event) => {
    setSuccess(null);
    setNames((names) => ({
      ...names,
      category: event.target.value,
    }));

    event.preventDefault();

    const fieldName = event.target.getAttribute("name");
    const category = event.target.value;

    const newFormData = { ...editFormData };
    newFormData["category"] = category;

    setEditFormData(newFormData);
  };

  //handle on status change
  const onStatusChange = (event) => {
    setSuccess(null);
    setNames((names) => ({
      ...names,
      status: event.target.value,
    }));

    event.preventDefault();

    const fieldName = event.target.getAttribute("name");
    const status = event.target.value;

    const newFormData = { ...editFormData };
    newFormData["status"] = status;

    setEditFormData(newFormData);
  };

  // handle gender input
    const onGenderChange = (event) => {
    setSuccess(null);
    setNames((names) => ({
      ...names,
      gender: event.target.value,
    }));

    event.preventDefault();

    const fieldName = event.target.getAttribute("name");
    const gender = event.target.value;

    const newFormData = { ...addFormData };
    newFormData["gender"] = gender;

    setAddFormData(newFormData);
  };

  //handle category input
  const onCategoryChange = (event) => {
    setSuccess(null);
    setNames((names) => ({
      ...names,
      category: event.target.value,
    }));

    event.preventDefault();

    const fieldName = event.target.getAttribute("name");
    const category = event.target.value;

    const newFormData = { ...addFormData };
    newFormData["category"] = category;

    setAddFormData(newFormData);
  };

  const onPhoneChange = (event) => {
    setNames((names) => ({
      ...names,
      phone: event.target.value,
    }));

    event.preventDefault();

    const fieldName = event.target.getAttribute("name");
    const category = event.target.value;

    const newFormData = { ...addFormData };
    newFormData["category"] = category;

    setAddFormData(newFormData);
  };

  //data fetching
  useEffect(() => {
    //fetch users
    const fetchAll = () => {
      let adminCookie = Cookies.get("sessionidadmin");
      if (adminCookie.length >= 1) {
        setIsLoading(true);

        setTimeout(() => {
          fetch("https://api.terraweb.africa/getTWUsers", {
            method: "post",
            headers: { "Content-Type": "application/JSON" },
            body: JSON.stringify({
              adminid: adminCookie,
            }),
          })
            .then(function (response) {
              if (response.status === 400) {
                throw Error("Wrong credentials");
              }
              if (response === 500) {
                throw Error("Could not complete request because of an error");
              }

              return response.json();
            })
            .then((user) => {
              if (user[0].id >= 1) {
                //load data
                setFoundErrAdd(null);

                setIsLoading(null);
                setContacts(user);
                loadAnalysis(user);

                setSuccess(null);
                setDeleteState(null);

                //store a name after load to display in the title of the users table
                setNames((names) => ({
                  ...names,
                  company: user[0].company,
                }));
              } else {
                //dont load

                setFoundErrAdd(null);
                setFoundErr(null);
                setIsLoading(null);
                setDeleteState(null);
              }
            })
            .catch((err) => {
              // setFoundErr(err.message);
              setIsLoading(null);
              // setFlag(1);
            });
        }, 1500);
      } else {
        setIsLoading(null);
      }
    };

    //load profile
    const fetchProfile = () => {
      let adminCookie = "";
      adminCookie = Cookies.get("sessionidadmin");
      let userid = "";
      userid = Cookies.get("sessioniduser");
      if (adminCookie.length >= 1 || userid.length >= 1) {
        setIsLoading(true);
        setTimeout(() => {
          fetch("https://api.terraweb.africa/loadProfile", {
            method: "post",
            headers: { "Content-Type": "application/JSON" },
            body: JSON.stringify({
              adminid: adminCookie,
              userid: userid,
            }),
          })
            .then(function (response) {
              if (response.status === 400) {
                throw Error("Wrong credentials");
              }
              if (response === 500) {
                throw Error("Could not complete request because of an error");
              }

              return response.json();
            })
            .then((user) => {
              if (user[0].username.length >= 1) {
                //load data

                setFoundErrAdd(null);

                setIsLoading(null);
                setContacts(user);

                setSuccess(null);
                setDeleteState(null);

                //store a name after load to display in the title of the users table
                setNames((names) => ({
                  ...names,
                  company: user[0].company,
                }));

                setAddFormData((prevState) => ({
                  ...prevState,
                  company: user[0].company,
                }));
                companyRef.current.value = user[0].company;
              } else {
                //dont load

                setFoundErrAdd(null);
                setFoundErr(null);
                setIsLoading(null);
                setDeleteState(null);
              }
            })
            .catch((err) => {
              // setFoundErr(err.message);
              setIsLoading(null);
              // setFlag(1);
            });
        }, 150);
      } else {
        setIsLoading(null);
      }
    };

    fetchAll();
    fetchProfile();
  }, []);

  //success and error messages
  // timer for success and error message
  // Success/Error auto-hide after 8 seconds
  useEffect(() => {
    if (success || foundErrAdd) {
      const timer = setTimeout(() => {
        setSuccess("");
        setFoundErrAdd("");
        fetchUsers()
        setEditContactId(null);
      }, 3000);

      return () => clearTimeout(timer); // cleanup
    }
  }, [success, foundErrAdd]);

  //load analysis
  const loadAnalysis = (datamap) => {
    settotalUsers(datamap.length);
    let count = 0;

    var i;
    for (i = 0; i < datamap.length; i++) {
      count = datamap[i].length;
    }
    settotalActiveUsers(count);
  };

  //search users
  const searchUsers = () => {
    // setContacts(null);
    //fetch cookie
    let adminCookie = Cookies.get("sessionidadmin");
    if (adminCookie.length >= 1) {
      setIsLoading(true);

      setTimeout(() => {
        fetch("https://api.terraweb.africa/searchUsers", {
          method: "post",
          headers: { "Content-Type": "application/JSON" },
          body: JSON.stringify({
            adminid: adminCookie,
            username: searchUser,
            email: searchUser,
            phone: searchUser,
            company: searchUser,
            userid: searchUser,
          }),
        })
          .then(function (response) {
            if (response.status === 400) {
              throw Error("Wrong credentials");
            }
            if (response === 500) {
              throw Error("Could not complete request because of an error");
            }

            return response.json();
          })
          .then((user) => {
            if (user[0].id >= 1) {
              setFoundErr(null);
              setFoundErrAdd(null);
              setDeleteState(null);

              setIsLoading(null);
              setContacts(user);
              loadAnalysis(user);

              //load data
            } else {
              //dont load

              setFoundErr(null);
              setFoundErrAdd(null);
              setIsLoading(null);
              setDeleteState(null);
            }
          })
          .catch((err) => {
            // setFoundErr(err.message);
            setIsLoading(null);
            // setFlag(1);
          });
      }, 1500);
    } else {
      setIsLoading(null);
    }
  };

  //fetch users
  const fetchUsers = () => {
    //fetch cookie
    let adminCookie = Cookies.get("sessionidadmin");
    if (adminCookie.length >= 1) {
      setIsLoading(true);

      setTimeout(() => {
        fetch("https://api.terraweb.africa/getTWUsers", {
          method: "post",
          headers: { "Content-Type": "application/JSON" },
          body: JSON.stringify({
            adminid: adminCookie,
          }),
        })
          .then(function (response) {
            if (response.status === 400) {
              throw Error("Wrong credentials");
            }
            if (response === 500) {
              throw Error("Could not complete request because of an error");
            }

            return response.json();
          })
          .then((user) => {
            if (user[0].id >= 1) {
              setFoundErr(null);
              setFoundErrAdd(null);
              setDeleteState(null);

              setIsLoading(null);
              setContacts(user);
              loadAnalysis(user);

              //load data
            } else {
              //dont load

              setFoundErr(null);
              setFoundErrAdd(null);
              setIsLoading(null);
              setDeleteState(null);
            }
          })
          .catch((err) => {
            // setFoundErr(err.message);
            setIsLoading(null);
            // setFlag(1);
          });
      }, 1500);
    } else {
      setIsLoading(null);
    }
  };

  //temp handle add form change
  const handleAddFormChange = (event) => {
    event.preventDefault();

    setSuccess(null);
    setFoundErrAdd(null);

    const fieldName = event.target.getAttribute("name");
    let fieldValue = event.target.value;

    // Check if the field name is "company" and apply formatting if needed
    if (fieldName === "company") {
      // Ensure the first letter is capitalized
      fieldValue = fieldValue.charAt(0).toUpperCase() + fieldValue.slice(1);

      // Remove trailing white spaces
      fieldValue = fieldValue.trim();
      setAddFormData((prevState) => ({
        ...prevState,
        company: fieldValue,
      }));
    } else if (fieldName === "firstName") {
      // Handle input changes for first name
      if (/^[A-Za-z]+$/.test(fieldValue) || fieldValue === "") {
        const fullName = formatFullName(fieldValue, addFormData.firstName);

        setAddFormData((prevState) => ({
          ...prevState,
          firstName: fieldValue,
          fullname: fullName,
        }));
      }
    } else if (fieldName === "lastName") {
      // Handle input changes for last name
      if (/^[A-Za-z]+$/.test(fieldValue) || fieldValue === "") {
        const fullName = formatFullName(addFormData.firstName, fieldValue);
        setAddFormData((prevState) => ({
          ...prevState,
          lastName: fieldValue,
          fullname: fullName,
        }));
      }
    } else {
      const newFormData = { ...addFormData };
      newFormData[fieldName] = fieldValue;

      setAddFormData(newFormData);
    }
  };

  const handleEditFormChange = (event) => {
    event.preventDefault();

    const fieldName = event.target.getAttribute("name");

    const fieldValue = event.target.value;

    const newFormData = { ...editFormData };
    newFormData[fieldName] = fieldValue;

    setEditFormData(newFormData);
  };

  //refresh after add records
  const refreshUsers = () => {
    fetchUsers();
  };

  //add user to the database
  // const handleAddFormSubmit = (event) => {
  //   event.preventDefault();
  //   setSuccess(null);
  //   setFoundErrAdd(null);

  //   const newContact = {
  //     username: addFormData.username,
  //     farmerid: addFormData.farmerid,
  //     email: addFormData.email,
  //     password: addFormData.password,
  //     fullname: addFormData.fullname,
  //     company: addFormData.company,
  //     category: addFormData.category,
  //     phone: addFormData.phone,
  //     gender:addFormData.gender
  //   };

  //   if (
  //     newContact.username.length >= 1 &&
  //     newContact.email.length >= 1 &&
  //     newContact.password.length >= 8 &&
  //     newContact.company.length >= 1 &&
  //     newContact.category.length >= 1 &&
  //     newContact.phone.length === 10 &&
  //     newContact.fullname.length >= 1 &&  newContact.gender.length >= 1
  //   ) {
  //     //send add agent request

  //     let adminCookie = Cookies.get("sessionidadmin");
  //     if (adminCookie.length >= 1) {
  //       setIsLoadingAdd(true);
  //       setTimeout(() => {
  //         fetch("https://api.terraweb.africa/addUser", {
  //           method: "post",
  //           headers: { "Content-Type": "application/JSON" },
  //           body: JSON.stringify({
  //             adminid: adminCookie,
  //             farmerid: newContact.farmerid,
  //             username: newContact.username,
  //             email: newContact.email,
  //             password: newContact.password,
  //             fullname: newContact.fullname,
  //             company: newContact.company,
  //             category: newContact.category,
  //             phone: newContact.phone,
  //             gender: newContact.gender,
  //           }),
  //         })
  //           .then(function (response) {
  //             if (response.status === 400) {
  //               throw Error(
  //                 "A user with the same details seems to already exist, or there seems to be an error."
  //               );
  //             }
  //             if (response.status === 417) {
  //               throw Error("Fill all details");
  //             }
  //             if (response === 500) {
  //               throw Error("Could not complete request because of an error");
  //             }

  //             return response.json();
  //           })
  //           .then((user) => {
  //             if (user) {
  //               setSuccess("success");
  //               setFoundErrAdd(null);

  //               setFoundErr(null);

  //               setIsLoadingAdd(null);
  //               // setContacts(user);

  //               //refresh data
  //               refreshUsers();

  //               //clear textboxes
  //               usernameRef.current.value = "";
  //               emailRef.current.value = "";
  //               passwordRef.current.value = "";
  //               phoneRef.current.value = "";
  //               // //clear the add form array
  //               // addFormData.username = "";
  //               // addFormData.email = "";
  //               // addFormData.phone = "";
  //               // addFormData.fullname = "";
  //               // // addFormData.company = "";
  //               // // addFormData.category = "";
  //               // addFormData.password = "";
  //               //load data
  //             } else {
  //               setSuccess("not good");

  //               //dont load

  //               setFoundErrAdd(null);
  //               setIsLoadingAdd(null);
  //               addFormData.username = "";
  //             }
  //           })
  //           .catch((err) => {
  //             setSuccess("got error");

  //             setFoundErrAdd(err.message);
  //             setIsLoadingAdd(null);
  //             newContact.username = "";

  //             // setFlag(1);
  //           });
  //       }, 1000);
  //     } else {
  //       setIsLoadingAdd(null);
  //     }
  //   } else {
  //   }
  // };

  // new add user with cleanups
  const handleAddFormSubmit = async (event) => {
    
  event.preventDefault();
  
console.log(addFormData)
  setSuccess(null);
  setFoundErrAdd(null);

  const { username, farmerid, email, password, fullname, company, category, phone, gender } = addFormData;

  // Basic validation
  if (
    !username || !email || !password || password.length < 8 ||
    !fullname || !company || !category || !gender ||
    phone.length !== 10
  ) {
    setFoundErrAdd("Please fill all fields correctly. Password must be at least 8 chars and phone exactly 10 digits.");
    return;
  }

  const adminCookie = Cookies.get("sessionidadmin");
  if (!adminCookie) {
    setFoundErrAdd("Admin session not found. Please login again.");
    return;
  }

  const payload = {
    adminid: adminCookie,
    farmerid,
    username,
    email,
    password,
    fullname,
    company,
    category,
    phone,
    gender,
  };

  try {
    setIsLoadingAdd(true);

    const response = await fetch("https://api.terraweb.africa/addUser", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    });

    if (!response.ok) {
      // Handle specific status codes
      if (response.status === 400) {
        throw new Error("A user with this email or details already exists.");
      } else if (response.status === 417) {
        throw new Error("Please fill all required details.");
      } else if (response.status === 500) {
        throw new Error("Server error. Could not complete the request.");
      } else {
        throw new Error(`Unexpected error: ${response.status}`);
      }
    }

    const data = await response.json();

    // Success
 setSuccess(data || "User added successfully!");
    setFoundErrAdd(null);

    // Refresh users table
    refreshUsers();

// Clear refs if you are using them
    if (usernameRef.current) usernameRef.current.value = "";
    if (emailRef.current) emailRef.current.value = "";
    if (passwordRef.current) passwordRef.current.value = "";
    if (phoneRef.current) phoneRef.current.value = "";

    // Clear form
    setAddFormData({
      username: "",
      farmerid: "",
      email: "",
      password: "",
      fullname: "",
      company: "",
      category: "",
      phone: "",
      gender: "",
    });

    
// Clear form state
setNames({
  username: "",
  farmerid: "",
  email: "",
  password: "",
  fullname: "",
  company: "",  // resets company
  category: "", // resets category
  phone: "",
  gender: "",   // resets gender
});


  } catch (err) {
    // Graceful error handling
    setFoundErrAdd(err.message);
    setSuccess(null);
  } finally {
    setIsLoadingAdd(false);
  }
};


  //updated update code
  const handleEditFormSubmit = (event) => {
    event.preventDefault();

    const updatedUser = {
      id: editFormData.id,
      farmerid: editFormData.farmerid,
      username: editFormData.username,
      email: editFormData.email,
      password: editFormData.password,
      phone: editFormData.phone,
      category: editFormData.category,
      company: editFormData.company,
      status: editFormData.status,
 
    };

    const adminCookie = Cookies.get("sessionidadmin");

    if (adminCookie?.length >= 4) {
      setIsLoadingSave(true);

      // Optional delay for UX
      setTimeout(() => {
        fetch("https://api.terraweb.africa/updateUser", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            adminid: adminCookie,
            ...updatedUser,
          }),
        })
          .then((response) => {
            if (response.status === 400) {
              throw new Error(
                "An error occurred during update. Ensure a user category is selected and you have the necessary privileges."
              );
            }
            if (response.status === 500) {
              throw new Error("Server error. Please try again later.");
            }
            return response.json();
          })
          .then((result) => {
            if (result >= 1) {
              setSuccess("User details updated successfully");
              setFoundErr(null);
              setIsLoadingSave(false);
              setDeleteState(null);
              setEditContactId(null);
              refreshUsers(); // Refresh the list
            } else {
              setSuccess("Update failed.");
              setIsLoadingSave(false);
              setFoundErrAdd(null);
            }
          })
          .catch((err) => {
            setFoundErrAdd(err.message);
            setIsLoadingSave(false);
            setSuccess(null);
          });
      }, 1000);
    } else {
      setIsLoadingSave(false);
    }
  };


  //supply data to the editable row and the index the row should be displayed
  const handleEditClick = (event, contact) => {
    setNames((names) => ({
      ...names,
      category: "",
      status: "",
    }));
    event.preventDefault();
    setEditContactId(contact.id);

    const formValues = {
      id: contact.id,
      farmerid: contact.farmerid,
      username: contact.username,
      email: contact.email,
      password: contact.password,
      created: contact.created,
      category: contact.category,
      company: contact.company,
      phone: contact.phone,
      status: contact.status,
    };

    setEditFormData(formValues);
  };

  const handleCancelClick = () => {
    setEditContactId(null);
    setNames((names) => ({
      ...names,
      category: "",
      status: "",
    }));
  };

  //confirm delete user
  const onDeleteYes = (contactemail, category) => {
    let adminCookie = Cookies.get("sessionidadmin");
    if (adminCookie.length >= 4) {
      fetch("https://api.terraweb.africa/deleteAnyUser", {
        method: "post",
        headers: { "Content-Type": "application/JSON" },
        body: JSON.stringify({
          adminid: adminCookie,

          email: contactemail,
          category: category,
        }),
      })
        .then(function (response) {
          if (response.status === 400) {
            throw Error("An error occurred, during delete.");
          }
          if (response === 500) {
            throw Error("Could not complete request because of an error");
          }

          return response.json();
        })
        .then((user) => {
          //
          setDeleteState(user);

          if (user) {
            refreshUsers();
          } else {
            //dont load
          }
        })
        .catch((err) => {
          setFoundErrAdd(err.message);
        });
    } else {
    }
  };

  const handleDeleteClick = (contactemail, category) => {
    //delete alert
    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <div className="deletediv bg-white br3 bb b--black-10  gold pa2 w-100 shadow-5 center ">
            <h1>Confirm Delete Record</h1>
            <p className="f3 black">Sure you want to delete this user record with ID: {contactemail}?</p>
            <p className="b red f4">
              Note that this cannot be <b className="red f3">UNDONE</b>
            </p>
            <label
              className="dib w3 tc pa2 f3 ma2 white br-pill bg-red hover-bg-white hover-black "
              onClick={onClose}
            >
              No
            </label>
            <label
              className="dib w6 f5 fr tc pa3 white br-pill bg-blue hover-bg-red hover-white"
              onClick={() => {
                onDeleteYes(contactemail);
                onClose();
              }}
            >
              Yes, Delete it!
            </label>
          </div>
        );
      },
    });
  };



  //handle download table

  const handleDownloadTable = () => {
    const doc = new jsPDF();

    const currentDate = new Date().toLocaleString();

    // Header
    doc.setFontSize(16);
    doc.text('Terraweb.africa', 14, 15);
    doc.setFontSize(11);
    doc.text('Empowering farmers through technology', 14, 22);
    doc.setFontSize(10);
    doc.text(`Generated on: ${currentDate}`, 14, 28);


    // Table data
    const tableColumn = [
      'ID',
      'Username',
      'Email',

      'Phone',
      'Joined',
      'Company',
      'Last active',
      'Category',
      'Status',
    ];

    const tableRows = contacts?.map((contact) => [
      contact.id,
      contact.username,
      contact.email,
      contact.phone,
      contact.joined,
      contact.company,
      contact.lastactive,
      contact.category,
      contact.status,
    ]) || [];

    autoTable(doc, {
      head: [tableColumn],
      body: tableRows,
      startY: 35,
      styles: { fontSize: 9, color: "black" },
      headStyles: { fillColor: [252, 156, 28] },
      margin: { top: 35, bottom: 20 },
      didDrawPage: function (data) {
        // Footer
        const pageCount = doc.internal.getNumberOfPages();
        doc.setFontSize(9);
        doc.text(
          `Page ${doc.internal.getCurrentPageInfo().pageNumber} of ${pageCount}`,
          data.settings.margin.left,
          doc.internal.pageSize.height - 10
        );

        // Footer text
        doc.text(
          '© Terraweb.africa — All rights reserved.',
          data.settings.margin.left + 70,
          doc.internal.pageSize.height - 10
        );
      },
    });

    // Save PDF
    doc.save('farmer_records.pdf');
  };

  //pagination next
  const handlePageNext = () => {

  }

  const handlePagePrevious = () => {

  }

  //handle search user
  const onSearchChange = (event) => {
    event.preventDefault();
    setSearchUser(event.target.value);
  };
  return (
    <div className="app-container center br4 mt6 shadow-3">
      {isLoading ? (
        <div className="db mb2">
          <Circles type="Oval" color="#000080" height={40} width={80} />
        </div>
      ) : null}



      <div className="controlContainer center d-grid bg-white  br4 shadow-3 w-100">
        <div>
          <label className="ma2 black f3 b">
            Total Users
            <label className="strong red pa3">{totalUsers}</label></label>

          <label className="pa3 green f3 b">
            Total Active Users
            <label className="strong green pa3">{totalUsers}</label>
          </label>
        </div>
        <div className="grid-item  ">
          <input
            type="text"
            className="searchInput "
            placeholder="Search users"
            onChange={onSearchChange}
          />


          <label className="pa1 hover-bg-transparent" onClick={searchUsers}>
            <i className="fas fa-search f2 hover-gold orange"></i>
            <span className=""></span>
          </label>
        </div>
        <div className="grid-item ">
          <label className="f3  ">
            Showing <b>1-50</b> of <b> {contacts.length} </b>Entries
          </label>
          {/* <button
              className=" br-pill bw0 ml2 bg-white orange f4  b pa2 hover-bg-orange hover-white"
              type="submit"
              onClick={handleAddFormSubmit}
            >
              back
            </button> */}
          {/* <button
              // className=" br-pill bw0 ml2 bg-white orange f4  b pa2 hover-bg-orange hover-white"
              className=" fas fa-caret-left f2 hover-gold"
              type="submit"
              onClick={handleAddFormSubmit}
            >
              next
            </button> */}
          <label className="pa3 hover-bg-transparent" onClick={handlePagePrevious}>
            <i className="fas fa-caret-left f2 hover-gold"></i>
            <span className=""></span>
          </label>
          <label className="pa3 hover-bg-transparent" onClick={handlePageNext}>
            <i className="fas fa-caret-right f2 hover-gold"></i>
            <span className=""></span>
          </label>
          <label className="pa3 hover-bg-transparent" onClick={handleDownloadTable}>
            <i className="fas fa-download f2 hover-gold"></i>
            <span className=""></span>
          </label>
        </div>
      </div>
      <div className="bg-white pa2 br4 shadow-2">
        <form onSubmit={handleEditFormSubmit}>
          <table>
            <thead>
              <tr>
                <th className="bg-gold">ID</th>
                <th className="bg-gold" >Farmer ID</th>
                <th className="bg-gold">Username</th>
                <th className="bg-gold">Email</th>
                <th className="bg-gold">Password</th>
                <th className="bg-gold">Phone</th>

                <th className="bg-gold">Created</th>
                <th className="bg-gold">Company</th>

                <th className="bg-gold">Last Active</th>
                <th className="bg-gold">Priviledges</th>
                <th className="bg-gold">Status</th>
                <th className="bg-gold">Edit Users</th>
              </tr>
            </thead>
            <tbody>
              {contacts.map((contact) => (
                <Fragment key={contact.id}>
                  {editContactId === contact.id ? (
                    <EditableRow
                      handleEditFormSubmit={handleEditFormSubmit}
                      isLoadingSave={isLoadingSave}
                      editFormData={editFormData}
                      handleEditFormChange={handleEditFormChange}
                      handleCancelClick={handleCancelClick}
                      onStatusChange={onStatusChange}
                      names={names}
                      handleCategoryEdit={handleCategoryEdit}
                      handleDeleteClick={handleDeleteClick}
                      optionsPreviledges={options}
                      contact={contact}
                      foundErrAdd={foundErrAdd}
                    />
                  ) : (
                    <ReadOnlyRow
                      contact={contact}
                      handleEditClick={handleEditClick}
                      handleDeleteClick={handleDeleteClick}

                    />
                  )}
                </Fragment>
              ))}
            </tbody>
          </table>
        </form>
      </div>
      <div>
        {foundErr ? <label className="dt red  pb2">{foundErr}</label> : null}

        <button
          className="ml2 br-pill bg-white orange f3 pa3 b mt2 hover-bg-orange hover-white"
          onClick={refreshUsers}
        >
          Refresh
        </button>
      </div>
      <div className="form-container bg-white pa3 br4 shadow-3 w-90-l w-100">
        <h2 className="f3 b gold">Add a User/ Clerk/ Admin</h2>
        <div className="grid-fields">

          <div>
            <h2>
              <label className="b f4 ">Farmer ID (autogenerated based on company choosen)</label>
            </h2>
            <input
              // ref={firstnameref}
              className=" tl"
              placeholder="Farmer ID"
              type="text"
              disabled
              name="farmerid"
              onChange={handleAddFormChange} />
          </div>
          <div>
            <h2>
              <label className="b f4 ">First Name</label>
            </h2>
            <input
              ref={firstnameref}
              className="tl  "
              placeholder="First Name"
              type="text"
              name="firstName"
              // value={addFormData.firstName}
              onChange={handleAddFormChange} />

          </div>
          <div>
            <h2>
              <label className="b f4 ">Last Name</label>
            </h2>
            <input
              ref={lastnameref}
              className="tl  "
              placeholder="Last Name"
              name="lastName"
              type="text"
              // value={addFormData.lastName}
              onChange={handleAddFormChange}
            />
          </div>
          <div>
            <h2>
              <label className="b f4 ">Username</label>
            </h2>
            <input
              className=" tl  "
              ref={usernameRef}
              type="text"
              name="username"
              required="required"
              placeholder="Enter a username..."
              onChange={handleAddFormChange} />
          </div>
          <div>
            <h2>
              <label className="b f4 ">Email</label>      </h2>
            <input className=" tl  "
              ref={emailRef}
              type="text"
              name="email"
              required="required"
              placeholder="Enter email..."
              onChange={handleAddFormChange} />
          </div>
          <div>
            <h2>
              <label className="b f4 ">Password</label> </h2>
            <input className="  tl  "
              ref={passwordRef}
              type="text"
              name="password"
              required="required"
              placeholder="Enter password..." onChange={handleAddFormChange} />
          </div>
          <div>
            <h2>
              <label className="b f4 ">Phone</label> </h2>
            <input className="  tl  " ref={phoneRef} type="text"
              // pattern="[0-9]*"
              pattern="[0-9]*"
              value={val}
              onInput={(e) =>
                setVal((v) => (e.target.validity.valid ? e.target.value : v))
              }
              placeholder="Enter Phone Number"
              name="phone" onChange={handleAddFormChange} ></input>
          </div>
          <div>
            <b className="b f4">Choose gender</b>
        <select
          className="rounded f4 bg-white tracked br-pill w-25-l w-25-m"
          value={names.gender}
          onChange={onGenderChange}
         ref={genderRef} 
        >
          {optionsGender.map((option) => (
            <option key={option.value} value={option.value}>
              {option.text}
            </option>
          ))}
        </select>
          </div>
          <div>
          
              <b className="b f4">Choose the company</b>
            <select id="company" className="rounded f4 bg-white tracked br-pill w-25" value={names.company}
              onChange={handleCompanyChange} required>
              {/* onChange={(e) => setNames((prev) => ({ ...prev, company: e.target.value }))} required> */}
              <option value="">-- Choose a company --


              </option>
              {(Array.isArray(companiesList) ? companiesList : []).map((company, idx) => (
                <option key={idx} value={company.name}>
                  {company.name}
                </option>
              ))}</select>
          </div>

          <div>
              <b className="b f4">Assign Category</b>
                 <select ref={categoryRef} className=" rounded f4 bg-white tracked br-pill ml2 w-25 w-20-m"
                 value={names.category}
                 onChange={onCategoryChange}>  {options.map((option) => (
                   <option key={option.value} value={option.value}>
                    {option.text}
                    </option>
                  ))} </select>
              </div>

          {isLoadingAdd ? (
            <div className="dib ml2 mr2">
              <Circles type="Oval" color="#000080" height={20} width={40} />
            </div>
          ) : null}

          <div className="">
            <label
              className=" br-pill  bg-gold white f3  b pa2 hover-bg-orange hover-white"
              // type="submit"
              onClick={handleAddFormSubmit}
            >
              Add
            </label>{foundErrAdd ? (
              <label className=" f3 bg-white hover-dark-red br-pill pa3 red b dt">
                {foundErrAdd}
              </label>
            ) : null}
          </div>
          {deleteState ? (
            <label className="card-tite w-70 f3 bg-white hover-dark-red br-pill pa1 mt2 red b dt">
              {deleteState}
            </label>
          ) : null}

          {success === "success" ? (
            <p className="card-tite w-50 f3 bg-white hover-blue br-pill pa1 green b">
              Account details updated successfully.
            </p>
          ) : null}
          {success === "not good" ? (
            <p className="card-tite w-50 f3 bg-white hover-dark-red br-pill pa1 red b">
              Error updating Account. Check your details and try again.
            </p>
          ) : null}
        </div>
      </div>
      <div className="bg-white shadow-2  mt2 pa2 br4">
        <label className="f3 b black ">Note:</label>
        <label className="f3 b black">
          You can alter a user or Admin that belong to any company. Fill the form inputs carefully!
        </label>
      </div>

    </div>
  );
};

export default TwUsers;
